import { LitElement, html, css } from 'lit';
import './orange_button_link';

class SportsTypeModalButton extends LitElement {
  static properties = {
    isOpen: { type: Boolean, reflect: true },
    sportsType: { type: String, reflect: true },
    description: { type: String, reflect: true },
    iconPath: { type: String, reflect: true },
    searchUrl: { type: String, reflect: true }
  }
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.isOpen = false;
  }
  static styles = css`
    .sports-type-card {
      width: 100%;
      display: flex;
      background-color: #ffffff;
      box-shadow: 0px 2px #ced0d1;
      border-radius: 8px;
      height: 64px;
      align-items: center;
    }

    .sports-type-card .sports-type-icon {
      padding: 24px 8px;
      display: flex;
      flex-direction: column;
      border-right: 2px solid #eeeeee;
    }

    .sports-type-card .sports-type-icon img {
      width: 16px;
      height: 16px;
    }

    .sports-type-card .sports-type-label {
      padding: 13px 8px;
      font-weight: bold;
      font-size: 12px;
      line-height: 15px;
      text-align: start;
    }

    .sports-type-modal {
      animation: fadeIn 0.3s ease 0s 1 normal;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 2000;
      display: flex;
      justify-content: center;
    }

    .sports-type-modal .modal-content-wrap {
      display: flex;
      flex-direction: column;
      gap: 16px;
      justify-content: center;
      align-items: center;
      width: 100%;
      max-width: 360px;
    }

    .sports-type-modal .modal-content-wrap .close-button-wrap {
      width: 100%;
      display: flex;
      justify-content: end;
    }

    .sports-type-modal .modal-content-wrap .close-button-wrap .close-button .close-button-text {
      color: #A8ABA6;
      font-size: 10px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%;
    }

    .sports-type-modal .modal-content-wrap .modal-content {
      position: relative;
      box-sizing: border-box;
      border-radius: 8px;
      background-color: #FFF;
      padding: 24px 24px 28px 24px;
      width: 100%;
    }

    .sports-type-modal .modal-content-wrap .modal-content .title {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 24px;
      border-bottom: 1px solid #A8ABA6;
      padding-bottom: 24px;
    }

    .sports-type-modal .modal-content-wrap .modal-content .title .icon {
      height: 24px;
    }

    .sports-type-modal .modal-content-wrap .modal-content .title .icon img {
      width: 24px;
      height: 24px;
    }

    .sports-type-modal .modal-content-wrap .modal-content .title .label {
      font-weight: bold;
      font-size: 16px;
      line-height: 20px;
      text-align: start;
    }

    .sports-type-modal .modal-content-wrap .modal-content .description {
      text-align: start;
      margin-bottom: 40px;
    }

    .sports-type-modal .modal-content-wrap .orange-button-link-content {
      display: flex;
      gap: 8px;
      font-style: normal;
      font-weight: 700;
      line-height: 150%;
      align-items: center;
    }

    @keyframes fadeIn {
      0% {
        opacity: 0;
      }
    100% {
      opacity: 1;
    }
  }
    `
  updated(changedProperties) {
  }
  closeModal() {
    this.isOpen = false;
  }
  openModal() {
    this.isOpen = true;
  }
  render() {
    return html`
      <div class="sports-type-card" @click="${this.openModal}">
        <div class="sports-type-icon">
          <img src="${this.iconPath}">
        </div>
        <div class="sports-type-label">
          ${this.sportsType}
        </div>
      </div>
      ${this.isOpen ? html`
        <div class="sports-type-modal">
          <div class="modal-content-wrap">
            <div class="close-button-wrap" @click="${this.closeModal}">
              <div class="close-button">
                <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
                  <path d="M7.38921 40L4 36.6108L18.6108 22L4 7.38921L7.38921 4L22 18.6108L36.6108 4L40 7.38921L25.3892 22L40 36.6108L36.6108 40L22 25.3892L7.38921 40Z" fill="white"/>
                </svg>
                <div class="close-button-text">
                  閉じる
                </div>
              </div>
            </div>
            <div class="modal-content">
              <div class="title">
                <div class="icon">
                  <img src="${this.iconPath}">
                </div>
                <div class="label">
                  ${this.sportsType}
                </div>
              </div>
              <div class="description">
                ${this.description}
              </div>
              <orange-button-link href="${this.searchUrl}">
                <div class="orange-button-link-content">
                  <div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <g clip-path="url(#clip0_3936_13490)">
                        <path d="M15.0193 16L9.17404 10.1548C8.70871 10.539 8.17359 10.8396 7.56867 11.0568C6.96374 11.2739 6.33794 11.3825 5.69126 11.3825C4.10062 11.3825 2.75442 10.8318 1.65265 9.73029C0.550884 8.6288 0 7.28295 0 5.69273C0 4.10249 0.550744 2.75614 1.65223 1.65368C2.75372 0.551225 4.09958 0 5.68982 0C7.28004 0 8.62638 0.550885 9.72885 1.65265C10.8313 2.75442 11.3825 4.10062 11.3825 5.69126C11.3825 6.35584 11.271 6.99059 11.0479 7.59552C10.8247 8.20044 10.527 8.72661 10.1548 9.17404L16 15.0193L15.0193 16ZM5.69126 9.98659C6.89038 9.98659 7.90604 9.57048 8.73826 8.73826C9.57048 7.90604 9.98659 6.89038 9.98659 5.69126C9.98659 4.49215 9.57048 3.47648 8.73826 2.64426C7.90604 1.81204 6.89038 1.39593 5.69126 1.39593C4.49215 1.39593 3.47648 1.81204 2.64426 2.64426C1.81206 3.47648 1.39595 4.49215 1.39595 5.69126C1.39595 6.89038 1.81206 7.90604 2.64426 8.73826C3.47648 9.57048 4.49215 9.98659 5.69126 9.98659Z" fill="white"/>
                      </g>
                      <defs>
                        <clipPath id="clip0_3936_13490">
                          <rect width="16" height="16" fill="white"/>
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <div>
                    ${this.sportsType}ができるスポーツ施設を探す
                  </div>
                </div>
              </orange-button-link>
            </div>
            <div style="height: 74px; width: 1px;"></div>
          </div>
        </div>
      ` : ''}
    `;
  }
}

if (!customElements.get('sports-type-modal-button'))
  customElements.define('sports-type-modal-button', SportsTypeModalButton);